import { Component, Input, Output, EventEmitter, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR, FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-inputfiled',
  imports: [CommonModule, FormsModule],
  templateUrl: './inputfiled.html',
  styleUrl: './inputfiled.css',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => Inputfiled),
      multi: true
    }
  ]
})
export class Inputfiled implements ControlValueAccessor {
  @Input() label: string = '';
  @Input() placeholder: string = '';
  @Input() type: string = 'text';
  @Input() required: boolean = false;
  @Input() disabled: boolean = false;
  @Input() errorMessage: string = '';
  @Input() maxLength: number = 0;
  @Input() inputRestriction: 'alphabets' | 'numbers' | 'email' | 'none' = 'none';
  @Input() hasError: boolean = false;

  value: string = '';
  
  private onChange = (value: string) => {};
  private onTouched = () => {};

  writeValue(value: string): void {
    this.value = value || '';
  }

  registerOnChange(fn: (value: string) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  onInput(event: Event): void {
    const target = event.target as HTMLInputElement;
    let inputValue = target.value;
    
    
    if (this.inputRestriction === 'alphabets') {
      inputValue = inputValue.replace(/[^a-zA-Z\s]/g, '');
    } else if (this.inputRestriction === 'numbers') {
      inputValue = inputValue.replace(/[^0-9]/g, '');
      
      if (this.type === 'tel' && inputValue.length > 0) {
        inputValue = this.formatPhoneNumber(inputValue);
      }
    } else if (this.inputRestriction === 'email') {
    
      inputValue = inputValue.replace(/[^a-zA-Z0-9@.\-_+]/g, '');
    }
    
    
    if (this.maxLength > 0 && inputValue.length > this.maxLength) {
      inputValue = inputValue.substring(0, this.maxLength);
    }
    
    this.value = inputValue;
    target.value = inputValue;  
    this.onChange(this.value);
  }

  private formatPhoneNumber(value: string): string {
    const cleaned = value.replace(/\D/g, '');
    const match = cleaned.match(/^(\d{0,3})(\d{0,3})(\d{0,4})$/);
    if (match) {
      return !match[2] ? match[1] : `${match[1]}-${match[2]}${match[3] ? `-${match[3]}` : ''}`;
    }
    return value;
  }

  onBlur(): void {
    this.onTouched();
  }
}
